import { useState, useCallback } from "react";
import { useOktaAuth } from "@okta/okta-react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

function UserAccount() {
  const { oktaAuth, authState } = useOktaAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = useCallback(
    (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget),
    [],
  );
  const handleClose = useCallback(() => setAnchorEl(null), []);
  const handleLogout = useCallback(async () => {
    handleClose();
    await oktaAuth.signOut();
  }, [oktaAuth, handleClose]);

  const claims = authState?.idToken?.claims;

  return (
    <>
      <IconButton onClick={handleOpen} aria-label="user avatar" color="inherit">
        <AccountCircleIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="body1">{claims?.name}</Typography>
          <Typography variant="caption" color="text.secondary">
            {claims?.email as string}
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
}

export { UserAccount };
